import React, { useRef } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';

import { Intl, ModalForm } from 'components';
import MediaAudioService from 'api/MediaAudio';
import SettingsActions from 'store/reducers/Settings';
import { useFetch } from 'hooks';
import MultipleFile from '../Multiple';
import SingleFile from '../Single';

const FavouriteModal = ( {
  open, values, onClose, onSubmit, toggleErrorAlert,
} ) => {
  const modalFormRef = useRef( null );

  const [data, dataLoading] = useFetch( {
    initialState: { data: [] },
    promise: () => MediaAudioService.getMediaAudios( { limit: 0 } ),
    toggleErrorAlert,
    conditional: open,
    deps: [open],
    reInit: true,
  } );

  return (
    <ModalForm
      title={`${values.messageType}_${values.audioSource}`}
      showErrorsInHeader
      isLoading={dataLoading}
      size="lg"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={values}
      validate={( formValues ) => {
        const errors = {};
        if ( values.messageType === 'poll' && ( !formValues.introductionFile || !formValues.optionsFile || !formValues.farewellFile ) ) {
          errors.files = true;
        }
        return errors;
      }}
      body={( modalForm ) => {
        modalFormRef.current = modalForm;
        const modalState = modalForm.getState();
        return (
          <>
            {values.messageType === 'poll' && (
              <MultipleFile
                data={data.data}
                values={modalState.values}
              />
            )}
            {values.messageType === 'simple_message' && (
              <SingleFile
                data={data.data}
                field="singleFile"
              />
            )}
            {values.messageType === 'poll' && modalState.submitFailed && modalState.errors.files
            && <div className="error mt-1 text-md text-center"><Intl id="campaignThreeAudioError" /></div>}
            {values.messageType === 'simple_message' && modalState.submitFailed && modalState.errors.singleFile
            && <div className="error mt-1 text-md text-center"><Intl id="campaignOneAudioError" /></div>}
          </>
        );
      }}
      footer={(
        <Button
          color="app-default"
          size="app-sm"
          className="font-weight-700"
        >
          <Intl id="save" />
        </Button>
      )}
    />
  );
};

const mapDispatchToProps = ( {
  toggleErrorAlert: SettingsActions.toggleErrorAlert,
} );

export default connect( null, mapDispatchToProps )( FavouriteModal );
